/**
 * Provides an interface for modifying the list of rules associated with a `Field`.
 * ## Fields
 * Name | Description
 * --- | ---
 * model | The `Field` containing models associated with this view.
 * @module app/views/layer/DataFieldRulesEditor
 */
import Backbone from "backbone";
import FormInputView from "core/views/FormInputView";
import _ from "underscore";
import DataFieldRuleValueEditor from "app/views/layer/DataFieldRuleValueEditor";
import ButtonView from "core/views/ButtonView";

export default Backbone.View.extend({
  className: "options col-sm-12 data-field-rules-editor",
  template: _.template(
    '<div class="col-sm-9"><div class="form_block clearfix"><label for="label" class="control-label">Condition Values</label><select class="form-control" id="selectValues"></select></div></div><div class="field-toggles btn-group btn-group-xs"></div><div class="clear-fix rules"></div>'
  ),
  _skipEvents: false,
  _editingValue: null,

  initialize: function (options) {
    this.options = options;
    this.model = this.options.model;
    this.fields = this.options.fields;
  },
  render: function () {
    var self = this;
    self.$el.html(self.template(_.defaults({}, self.options, {})));
    var $selectValues = self.$("#selectValues");
    var $rules = self.$(".rules");
    var $rulesContainer = self.$(".rules-container");

    var addRule = new ButtonView({
      click: function () {
        self.addRule();
      },
      text: "",
      icon: "plus",
      className: "btn-primary btn-add",
      tooltip: "Add Rule",
      attributes: {
        tabindex: "-1",
      },
    });

    this.model.on(
      "value-rule-cleared",
      function (value) {
        if (!this._skipEvents) {
          var $selectValues = self.$("#selectValues");
          var optionValue = this.model.get("values").filter(function (f) {
            return f.value == value;
          });
          if (optionValue.length > 0) {
            $selectValues.append(
              "<option value='" +
                optionValue[0].value +
                "'>" +
                optionValue[0].text +
                "</option>"
            );
          }
        }
      },
      this
    );

    addRule.render();
    this.$(".field-toggles").append(addRule.$el);

    var values = this.model.get("values");
    _.each(
      values,
      function (optionValue) {
        if (optionValue.rules != undefined && optionValue.rules.length > 0) {
          var result = self._appendOptions(optionValue);
          $rules.append(result.$el);
        } else {
          if (optionValue.value.length > 0) {
            $selectValues.append(
              "<option value='" +
                optionValue.value +
                "'>" +
                optionValue.text +
                "</option>"
            );
          }
        }
      },
      this
    );
    if ($rules.html() == "") {
      $rulesContainer.hide();
    } else {
      $rulesContainer.show();
    }
  },
  addValue: function (optionValue) {
    var $selectValues = this.$("#selectValues");
    $selectValues.append(
      "<option value='" +
        optionValue.value +
        "'>" +
        optionValue.text +
        "</option>"
    );
  },
  removeValue: function (optionValue) {
    var $selectValues = this.$("#selectValues");
    $selectValues.find("option[value='" + optionValue.value + "']").remove();
    this.removeValueRules(optionValue.value);
  },
  removeValueRules: function (value) {
    var $rules = this.$(".rules");
    var $divRules = $rules.find("#divValueRules" + value);
    if ($divRules.length > 0) {
      $divRules[0].remove();
    }
  },
  _appendOptions: function (optionValue) {
    if (optionValue.rules == undefined) {
      optionValue.rules = [];
    }
    var result = new DataFieldRuleValueEditor(
      _.extend({
        model: optionValue,
        fields: this.fields,
        field: this.model,
      })
    );
    result.render();
    return result;
  },
  addRule: function () {
    var self = this;
    var $rulesContainer = self.$(".rules-container");
    var $rules = self.$(".rules");
    var $selectValues = self.$("#selectValues");
    var values = this.model.get("values");

    var newValues = values.filter(function (f) {
      if (f.value.length > 0) {
        return f.value == $selectValues[0].value;
      }
    });
    if (newValues.length > 0) {
      var optionValue = newValues[0];
      optionValue.rules = [];
      var result = new DataFieldRuleValueEditor(
        _.extend({
          model: optionValue,
          fields: this.fields,
          field: this.model,
        })
      );
      result.render();
      $rulesContainer.show();
      $rules.append(result.$el);
      $selectValues
        .find("option[value='" + $selectValues[0].value + "']")
        .remove();
      return false;
    }
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/layer/DataFieldRulesEditor.js
// module id = 888
// module chunks = 1